import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandDashboardPage } from './cabsand-dashboard';

@NgModule({
  declarations: [
    CabsandDashboardPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandDashboardPage),
  ],
})
export class CabsandDashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-dashboard/cabsand-dashboard.module.ts